import { createReducer } from '@reduxjs/toolkit';
import { TagBinderShape } from './model';
import * as tagBinderActions from './actions';

const initial: TagBinderShape = {
  tags: [],
  visible: false,
  inProgress: false,
};

export const tagBinderReducer = createReducer<TagBinderShape>(initial, (builder) =>
  builder
    .addCase(tagBinderActions.tagsLoaded, (s, a) => {
      s.tags = a.payload.tags;
    })
    .addCase(tagBinderActions.setVisible, (s, a) => {
      s.visible = a.payload.visible;
    })
    .addCase(tagBinderActions.setInProgress, (s, a) => {
      s.inProgress = a.payload.inProgress;
    }),
);
